// 应用版本配置
export const APP_VERSION = {
  android: {
    version: "4.0.0",
    downloadUrl:
      "http://cdn.yue-music.com/WeSing/Android/JiemoChang_4.0.0_Release.apk",
    fileName: "JiemoChang_4.0.0_Release.apk",
  },
  ios: {
    appStoreUrl: "https://apps.apple.com/cn/app/芥末唱/id6587564479",
  },
};

// 生成完整的下载链接
export const getAndroidDownloadUrl = () => {
  return APP_VERSION.android.downloadUrl;
};

// 生成文件名
export const getAndroidFileName = () => {
  return APP_VERSION.android.fileName;
};

// 生成iOS App Store链接
export const getIOSAppStoreUrl = () => {
  return APP_VERSION.ios.appStoreUrl;
};
